export default __webpack_public_path__ + "static/media/heart-search.f7e5e765.svg";